import request from '@/utils/request'

/**
 * 在线采购套餐查询
 * @param {*} params token, userId
 * @returns
 */
export const purOnlinePK = params => {
  return request({
    method: 'post',
    url: '/cm/purOnline/mobileList',
    data: params
  })
}

/**
 * 在线采购套餐价格查询
 * @param {*} params token, userId
 * @returns
 */
export const PriceChangePK = params => {
  return request({
    method: 'post',
    url: '/cm/purOnline/mobilePrice',
    data: params
  })
}

/**
 * 付款
 * @param {*} params token, userId, form
 * @returns
 */
export const OnlinePurchasing = params => {
  return request({
    method: 'post',
    url: '/cm/purOnline/mobileSubmit',
    data: params
  })
}

/**
 * 收货人信息等内容
 * @param {*} params token, userId
 * @returns
 */
export const userAdress = params => {
  return request({
    method: 'post',
    url: '/cm/purOnline/selectDeliveredInfo',
    data: params
  })
}

/**
 * 采购订单
 * @param {*} params token, userId
 * @returns
 */
export const userOrderList = params => {
  return request({
    method: 'post',
    url: '/cm/purOrder/mobileList',
    data: params
  })
}

/**
 * 采购订单详情
 * @param {*} params token, userId orderid
 * @returns
 */
export const userOrder = params => {
  return request({
    method: 'post',
    url: '/cm/purOrder/mobileDetail',
    data: params
  })
}

/**
 * ICCID卡数量
 * @param {*} params token, userId orderid
 * @returns
 */
export const ICCIDNum = params => {
  return request({
    method: 'post',
    url: '/cm/purOrder/mobileDelieveryQuantity',
    data: params
  })
}

/**
 * 订单发货校验
 * @param {*} params token, userId orderid
 * @returns
 */
export const DeliveryVerif = params => {
  return request({
    method: 'post',
    url: '/cm/purOrder/mobileDelieveryCheck',
    data: params
  })
}

/**
 * 订单发货确认
 * @param {*} params
 * token, userId, orderid, expressNo(物流单号), packageIds, iccidBegins, iccidEnds
 * @returns
 */
export const DeliveryConfirm = params => {
  return request({
    method: 'post',
    url: '/cm/purOrder/mobileDelieveryConfirm',
    data: params
  })
}

/**
 * 用户发货权限
 * @param {*} params token, userId
 * @returns
 */
export const getAdmin = params => {
  return request({
    method: 'post',
    url: '/system/user/isMobileAdmin',
    data: params
  })
}
